import React from "react";
import { Table, Card, Button } from "react-bootstrap";
import { formatDateTimeToReadableIndo } from "utils/dateHelpers";
import { formatPrice } from "utils/utils";
import Swal from "sweetalert2";
import { postRequest } from "services/api";

const CashierHistoryTable = ({ data, Pagination, refetch }) => {
  const handleCloseCashier = async (trx) => {
    const { value: formValues } = await Swal.fire({
      title: "Close Cashier Session",
      html:
        '<label class="form-label">Closing Balance</label>' +
        '<input id="swal-input1" class="form-control mb-3" type="number" placeholder="0">' +
        '<label class="form-label">Location</label>' +
        '<input id="swal-input2" class="form-control" type="text" placeholder="e.g. Resto Main">',
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Close Session",
      preConfirm: () => {
        return [
          document.getElementById("swal-input1").value,
          document.getElementById("swal-input2").value,
        ];
      },
    });

    if (formValues) {
      const [balance, location] = formValues;

      Swal.fire({
        title: "Processing...",
        text: "Closing cashier session",
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });

      try {
        const response = await postRequest("/cashier-session/closed", {
          balance: parseFloat(balance || 0),
          location: location || trx.location || "N/A",
        });

        if (response.success) {
          Swal.fire("Success", "Cashier session closed successfully", "success");
          if (refetch) refetch();
        } else {
          Swal.fire("Error", response.message || "Failed to close session", "error");
        }
      } catch (error) {
        console.error("Close cashier error:", error);
        Swal.fire("Error", error.message || "An error occurred", "error");
      }
    }
  };

  return (
    <div className="table-responsive">
      <Table striped bordered hover>
        <thead>
          <tr>
            <th>No</th>
            <th>Date</th>
            <th>Status / Info</th>
            <th>Opening Balance</th>
            <th>Closing Balance</th>
            <th>Total Sales</th>
            <th className="text-center">Action</th>
          </tr>
        </thead>
        <tbody>
          {data.length > 0 ? (
            data.map((trx, index) => (
              <tr key={trx.id}>
                <td>{index + 1}</td>
                <td>
                  <Card className="mb-2 border-0 shadow-none bg-light">
                    <Card.Body className="p-2">
                      <div className="small">
                        <strong>Opened By:</strong> {trx.cashier?.name || "-"} <br />
                        <strong>At:</strong>{" "}
                        {formatDateTimeToReadableIndo(trx.created_at)}
                      </div>
                    </Card.Body>
                  </Card>
                  {trx.status === "close" && (
                    <Card className="border-0 shadow-none bg-light">
                      <Card.Body className="p-2">
                        <div className="small">
                          <strong>Closed By:</strong> {trx.cashier?.name || "-"} <br />
                          <strong>At:</strong>{" "}
                          {trx.closed_at 
                            ? formatDateTimeToReadableIndo(trx.closed_at)
                            : formatDateTimeToReadableIndo(trx.updated_at)}
                        </div>
                      </Card.Body>
                    </Card>
                  )}
                </td>

                <td>
                  <div className="mb-1">
                    <span className={`badge ${trx.status === "open" ? "bg-success" : "bg-secondary"} text-white`}>
                      {trx.status.toUpperCase()}
                    </span>
                  </div>
                  <div className="small text-muted">
                    Loc: {trx.location || "-"}
                  </div>
                </td>
                <td>{formatPrice(trx.opening_balance)}</td>
                <td>{formatPrice(trx.closing_balance)}</td>
                <td>{formatPrice(trx.total_sales)}</td>
                <td className="text-center">
                  {trx.status === "open" && (
                    <Button 
                      variant="danger" 
                      size="sm" 
                      onClick={() => handleCloseCashier(trx)}
                    >
                      Close Session
                    </Button>
                  )}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="7" className="text-center py-4 text-muted">
                No transactions available
              </td>
            </tr>
          )}
        </tbody>
      </Table>
      <div className="mt-4 text-center">{Pagination}</div>
    </div>
  );
};

export default CashierHistoryTable;
